<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">评价服务费</span>
    </div>
    <el-table :data="tableData"
              border
              default-expand-all
              stripe :header-cell-style="{'text-align':'center'}"
              cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              class="tb-edit"
              highlight-current-row
              @row-click="handleCurrentChange">
      <el-table-column prop="taskClassStr" label="好评类型" align="right" />
      <el-table-column label="服务费">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.serviceMoney" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.serviceMoney}}</span>
        </template>
      </el-table-column>
      <el-table-column label="佣金">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.comissionMoney" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.comissionMoney}}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-card>

  <el-card>
    <el-form>
      <el-row :gutter="30" style="text-align: center">
        <el-col :span="10" style="text-align: right">
          <el-button type="info" icon="el-icon-back">返回</el-button>
        </el-col>
        <el-col :span="10" style="text-align: left">
          <el-button type="primary" icon="el-icon-folder" @click="handleSave">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</div>
</template>

<script>
import {
  getAllReviewServiceMoney,
  updateReviewServiceMoney,
  updateServiceMoney
} from "../../api/b2cbusiness/b2c_servicemoney";

export default {
  name: "GoodReviewPrice",
  data(){
    return {
      tableData: [
      ]
    }
  },
  mounted() {
    getAllReviewServiceMoney().then(res=>{
      if (res.success){
        this.tableData = res.data;
      }
    });
  },
  methods: {
    getData(){
      getAllReviewServiceMoney(null).then(res=>{
        if (res.success){
          this.tableData = res.data;
        }
      });
    },
    handleSave(){
      updateReviewServiceMoney(this.tableData).then(res=>{
        console.log(res.data)
        if (res.success){
          this.getData();
        }
      });
    },
    handleCurrentChange(row, event, column) {
      console.log(row, event, column, event.currentTarget)
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
      this.tableData.splice(index, 1);
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.el-tabs-self{
  position: relative;
  width: 100%;
}

span{
  text-align: center;
}
.tb-edit .el-input {
  display: none
}
.tb-edit .current-row .el-input {
  display: block
}
.tb-edit .current-row .el-input+span {
  display: none
}
</style>
